import "./style.css";

export default function RegionalHubHero({
  imageUrl,
  imageAlt = "",
  logoUrl,
  imagePosition,
  brandAssets,
  brandLabel,
  brandSubLabel,
}) {
  return (
    <section className="regional-hub-hero" aria-label={imageAlt}>
      {imageUrl ? (
        <img
          className="regional-hub-hero__image"
          src={imageUrl}
          alt={imageAlt}
          style={imagePosition ? { objectPosition: imagePosition } : undefined}
        />
      ) : (
        <div className="regional-hub-hero__placeholder" />
      )}

      {logoUrl && (
        <img
          className="regional-hub-hero__logo"
          src={logoUrl}
          alt=""
          aria-hidden="true"
        />
      )}

      {!logoUrl && brandAssets && (
        <div
          className="regional-hub-hero__brand regional-hub-hero__brand--assets"
          aria-hidden="true"
        >
          {brandAssets.flower && (
            <img
              className="regional-hub-hero__brand-flower-img"
              src={brandAssets.flower}
              alt=""
            />
          )}
          <span className="regional-hub-hero__brand-logos">
            {brandAssets.titleLogo && (
              <img src={brandAssets.titleLogo} alt="" />
            )}
            {brandAssets.subLogo && (
              <span className="regional-hub-hero__brand-subrow">
                <span />
                <img src={brandAssets.subLogo} alt="" />
                <span />
              </span>
            )}
          </span>
        </div>
      )}

      {!logoUrl && !brandAssets && brandLabel && (
        <div className="regional-hub-hero__brand" aria-hidden="true">
          <span className="regional-hub-hero__brand-text">
            <strong>{brandLabel}</strong>
            {brandSubLabel && <small>{brandSubLabel}</small>}
          </span>
        </div>
      )}
    </section>
  );
}
